import { createContext, useContext, useState, useEffect } from 'react';
import api from '../api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem('yuville_auth');
    const u = raw ? JSON.parse(raw) : null;
    // Set default auth header synchronously so child effects on reload/deep-link
    // do not fire protected API calls without Authorization.
    if (u?.token) api.defaults.headers.common['Authorization'] = `Bearer ${u.token}`;
    return u;
  });

  useEffect(() => {
    const t = user?.token;
    if (t) api.defaults.headers.common['Authorization'] = `Bearer ${t}`;
    else delete api.defaults.headers.common['Authorization'];
  }, [user]);

  const login = async (username, password) => {
    const { data } = await api.post('/auth/login', { username, password });
    localStorage.setItem('yuville_auth', JSON.stringify(data));
    setUser(data);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('yuville_auth');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, isAuth: !!user, isAdmin: user?.role === 'admin' }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth requires AuthProvider');
  return ctx;
}
